import { jsx } from 'react/jsx-runtime';
import { Table } from '@backstage/core-components';
import { CatalogTableToolbar } from './CatalogTableToolbar.esm.js';

function CursorPaginatedCatalogTable(props) {
  const { columns, data, next, prev, options, ...restProps } = props;
  return /* @__PURE__ */ jsx(
    Table,
    {
      columns,
      data,
      options: {
        ...options,
        // These settings are configured to force server side pagination
        pageSizeOptions: [],
        showFirstLastPageButtons: false,
        pageSize: Number.MAX_SAFE_INTEGER,
        emptyRowsWhenPaging: false
      },
      onPageChange: (page) => {
        if (page > 0) {
          next?.();
        } else {
          prev?.();
        }
      },
      components: {
        Toolbar: CatalogTableToolbar
      },
      page: prev ? 1 : 0,
      totalCount: next ? Number.MAX_VALUE : Number.MAX_SAFE_INTEGER,
      localization: { pagination: { labelDisplayedRows: "" } },
      ...restProps
    }
  );
}

export { CursorPaginatedCatalogTable };
//# sourceMappingURL=CursorPaginatedCatalogTable.esm.js.map
